import css from './deckGraph.module.scss';

import { memo, useEffect, useState } from 'react';

import { apiGetPendingGraph } from 'core/api';
import { EXERCISE_LABELS } from 'core/helpers/deck';
import usePromiseQuery from 'core/helpers/usePromiseQuery';
import { useMessageModal } from 'core/ui/MessageModal';
import Preloader from 'core/ui/Preloader';

import Graph from './Graph';
import { TTimeRecord } from './types';

const GraphExercise = ({
  exercise,
  deckUid,
}: {
  exercise: TExercise;
  deckUid: string;
}) => {
  const [query, isFetching] = usePromiseQuery(apiGetPendingGraph);

  const { showError } = useMessageModal();
  const [data, setData] = useState<TTimeRecord[] | null>(null);
  useEffect(() => {
    query(deckUid, exercise).then(setData).catch(showError);
  }, [deckUid]);

  return (
    <div className={css.exerciseBlock}>
      <h3 className={css.heading}>
        Exercise:
        <i>{EXERCISE_LABELS[exercise]}</i>
      </h3>
      {isFetching && <Preloader />}
      <div className={css.graphWrapper}>
        {!isFetching && data && <Graph data={data} />}
      </div>
    </div>
  );
};

export default memo(GraphExercise);
